// Generated types for ScopedNode
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { PrivateNodeReadAPI, PrivateNodeWriteAPI } from './privatenode';
import { PrivateNodeReadAPISchemaObject, PrivateNodeWriteAPISchemaObject } from './privatenode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ScopedNodeReadAPI extends PrivateNodeReadAPI {
  /** Creation timestamp (server-set) */
  created_at?: string | null;
}

export interface ScopedNodeWriteAPI extends PrivateNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ScopedNodeReadAPISchemaObject = PrivateNodeReadAPISchemaObject.extend({
  created_at: z.string().nullable().optional(),
}).passthrough();
export const ScopedNodeReadAPISchema: z.ZodType<ScopedNodeReadAPI> = ScopedNodeReadAPISchemaObject;

export const ScopedNodeWriteAPISchemaObject = PrivateNodeWriteAPISchemaObject.extend({}).passthrough();
export const ScopedNodeWriteAPISchema: z.ZodType<ScopedNodeWriteAPI> = ScopedNodeWriteAPISchemaObject;
